<div class="oven-view">
  <img
    class="oven-view__img"
    src="assets/file-browser/oven.png"
    alt="Feature not ready"
  />
  <p class="oven-view__text">
    {{ 'FILE_BROWSER.FEATURE_IN_OVEN' | translate }}
    <br> {{ 'FILE_BROWSER.FEATURE_IN_OVEN_WAIT' | translate }}
  </p>
</div>
